import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren } from 'react';
import { useCreditCardCompareColumnContext } from '../ColumnContext';
import { DetailBox } from '../components/DetailBox';
export function ConsContainer(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const {
    index
  } = useCreditCardCompareColumnContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "thumb-down-outlined",
      dataTestId: "thumb-down-icon"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== index) {
    t2 = <DetailBox title="Cons" index={index} icon={t1}>{children}</DetailBox>;
    $[1] = children;
    $[2] = index;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}